import api from './api';

const notificationAPI = {
  /**
   * Get current user's notification preferences
   * @returns {Promise<{email_notifications_enabled: boolean, discord_notifications_enabled: boolean, discord_user_id: string|null}>}
   */
  getPreferences: async () => {
    const response = await api.get('/api/users/me/notification-preferences');
    return response.data;
  },

  /**
   * Update notification preferences
   * @param {Object} preferences - Notification preferences
   * @param {boolean} preferences.email_notifications_enabled
   * @param {boolean} preferences.discord_notifications_enabled
   * @param {string|null} preferences.discord_user_id - 17-19 digit Discord ID
   * @returns {Promise<{message: string, preferences: Object}>}
   */
  updatePreferences: async (preferences) => {
    const response = await api.put('/api/users/me/notification-preferences', preferences);
    return response.data;
  },
};

export default notificationAPI;
